import { useState } from "react";
import styles from "./Popup.module.scss";
import Input from "../Input/Input";
import Label from "../Input/Label";
import TextArea from "../Input/Textarea";
import Button from "../Button/Button";
import { CheckEmail } from "../../Validation/Validations";
import BasicAPI from "../../API/BasicAPI";
import closeBtn from "../../Assets/Images/close_icon.png";
import { useNavigate } from "react-router-dom";

const Popup = ({ setPopupOpened, partnerID }) => {
  const navigate = useNavigate();

  const [formContent, setFormContent] = useState({
    partner: partnerID,
    name: "",
    email: "",
    title: "",
    message: "",
  });

  const onChangeForm = (e) => {
    const inputData = e.target;
    setFormContent((prev) => ({ ...prev, [inputData.name]: inputData.value }));
  };

  const submitForm = () => {
    if (formContent.name === "") {
      alert("이름을 입력하세요");
      return;
    }
    if (formContent.email === "") {
      alert("이메일을 입력하세요");
      return;
    }
    if (formContent.title === "") {
      alert("문의제목을 입력하세요");
      return;
    }
    if (formContent.message === "") {
      alert("문의내용을 입력하세요");
      return;
    }
    if (!CheckEmail(formContent.email)) {
      alert("이메일 주소가 유효하지 않습니다");
      return;
    }

    BasicAPI({
      url: `${process.env.REACT_APP_SERVICE_URL}/partner/client/contact/`,
      method: "POST",
      data: formContent,
      success: (res) => {
        alert(res.message);
        closePopup();
      },
      fail: (res) => console.error(res),
    });
  };

  const closePopup = () => {
    setPopupOpened(false);
    document.documentElement.style.overflow = "scroll";
  };

  return (
    <div
      className={styles.contact_popup}
      style={{ top: window.scrollY, left: 0 }}
    >
      <div className={styles.popup_window}>
        <div className={styles.close_btn}>
          <img src={closeBtn} alt="팝업창 닫기" onClick={closePopup} />
        </div>
        <div className={styles.form_wrapper}>
          <div className={styles.title}>문의하기</div>
          <form>
            <div className={styles.input_wrapper}>
              <Label label="이름" />
              <Input
                name="name"
                value={formContent.name}
                placeholder="이름을 입력해주세요"
                onChange={onChangeForm}
              />
            </div>
            <div className={styles.input_wrapper}>
              <Label label="이메일" />
              <Input
                name="email"
                value={formContent.email}
                placeholder="이메일 입력해주세요"
                onChange={onChangeForm}
              />
            </div>
            <div className={styles.input_wrapper}>
              <Label label="문의내용" />
              <Input
                name="title"
                value={formContent.title}
                placeholder="문의 제목"
                onChange={onChangeForm}
              />
              <TextArea
                name="message"
                rows="10"
                placeholder="내용을 입력해주세요"
                value={formContent.message}
                onChange={onChangeForm}
              />
            </div>
          </form>
          <div className={styles.button_wrapper}>
            <Button type="blue" text="완료" onClick={submitForm} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
